SessionService = ($http) ->
  create: (email, password) ->
    $http.post '/api/users/sign_in.json',
      email: email
      password: password

  destroy: ->
    $http.delete('/api/users/sign_out.json')

SessionService.$inject = [
  '$http'
]

module.exports = SessionService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/session/session-service.coffee